import { proxy } from "valtio";

const state = proxy({
  mode: "main",
  width: window.innerWidth,
  isMobile: window.innerWidth < 768,
  panel: null,
  autoRotate: false,
  isDragging: false,
  isHovered: false,
  finishedIntro: false,
  intro: true,
  finishedLoadingAsset: false,
  audioVolume: 0.3,
  isMusicPlaying: false,
  introTransition: null,

  // Initialize quality from localStorage to persist user preference across sessions
  // Using a safe read in case localStorage is unavailable (SSR or restricted env)
  qualitySettings: (typeof localStorage !== "undefined" && localStorage.getItem("qualitySettings")) || "balanced",
  finishedMainLoading: false,
  lightPosition: [50, 70, 100],
  hideInstruction: false,
  hoveredModel: false,
  hoveredElement: null, // Store the specific element being hovered
  hoveredElementName: "", // Store the display name for the hovered element
  openedPanel: null,
  presetColors: null, // Store preset colors for individual elements
  hullColor: null, // Store hull-specific color
  accentColor: null, // Store accent-specific color
  deckColor: null, // Store deck-specific color
  seatsColor: null, // Store seats-specific color
  bodyColor: null, // Store body-specific color
  environmentPreset: null, // Store current environment preset
  environmentColors: null, // Store environment colors
  environmentHdriUrl: "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/2k/kloppenheim_06_puresky_2k.hdr", // Store environment HDRI URL
  environmentBackgroundIntensity: 0.3, // Store environment background intensity
  lightPosition: [2, 3.5, 0],
  waterColor: {
    hue: 217,
    saturation: 84,
    luminosity: 38,
    alpha: 1,
  },
  waterRoughness: 0,
  luminosity: 90,
  currentEnvironment: localStorage.getItem("selectedEnvironment") || "sky",
  isMobile: window.innerWidth < 768,
  controlsEnabled: true,
  isDraggingCamera: false, // Track when user is dragging the camera with OrbitControls
  allowHover: true, // Allow hover interactions (disabled during intro and after drag)
  allowClick: true, // Allow click interactions (disabled during intro and after drag)
  viewType: "main", // "main", "deck", "bow", "cabin" default is main
});

const toggleMusic = (value) => {
  if (value !== undefined) {
    state.isMusicPlaying = value;
  } else {
    state.isMusicPlaying = !state.isMusicPlaying;
  }
};

export { state, toggleMusic };
